import * as React from "react";
import * as Redux from "redux";
import * as ReactDOM from "react-dom";
import thunkMiddleware from 'redux-thunk'
import {CommandCaller} from "../lib/commands";
import {SubscriptionAppStore,SubscriptionAppContainer} from "./module/subscription-list/app"
import {SubscriptionAppReducer} from "./module/subscription-list/reducers"
import {Reducer, StoreEnhancer} from "redux";
import {Store} from "react-redux";

export type SubscriptionCommandProps = {
	ajaxPageUrl:string
}

export type EditSubscriptionModalProps = {
	ajaxPageUrl:string
	subscriptionId:number
	name:string
	optional:boolean
	reason:string
}

export namespace admin {
	export const getSubscriptionGridData = (props:SubscriptionCommandProps) => {
		return (callback:(_:string) => void) => {
			const cc = new CommandCaller(props.ajaxPageUrl);
			cc.runGet('subscriptionmanager.subscriptions',{}).then(
				(response) => { callback((response as {content:string}).content) }
			)
		}
	}

	export const deleteSubscription = (props:SubscriptionCommandProps, ids:string) => {
		const cc = new CommandCaller(props.ajaxPageUrl);
		cc.runPost('subscriptionmanager.deleteSubscription',{ids: ids}).then(
			() => { refreshSubscriptionList() }
		)
	}

	export const addSubscriptionModal = (props:SubscriptionCommandProps) => {
		const div = document.createElement('div');
		const body = document.getElementsByTagName('body')[0];
		body.appendChild(div);

		const initialState:SubscriptionAppStore = {
			name: '',
			optional: true,
			reason: '',
			isSaving: false
		}
		const store = Redux.createStore<SubscriptionAppStore>(
			SubscriptionAppReducer,
			initialState,
			Redux.applyMiddleware(thunkMiddleware)
		)

		ReactDOM.render(<SubscriptionAppContainer
			store={store}
			ajaxPageUrl={props.ajaxPageUrl}
			onClose={()=>{
				ReactDOM.unmountComponentAtNode(div)
				refreshSubscriptionList()
			}}
		/>,div)
	}

	export const editSubscriptionModal = (props:EditSubscriptionModalProps) => {
		const div = document.createElement('div');
		const body = document.getElementsByTagName('body')[0];
		body.appendChild(div);

		const initialState:SubscriptionAppStore = {
			subscriptionId: props.subscriptionId,
			name: props.name,
			optional: props.optional,
			reason: props.reason,
			isSaving: false
		}
		
		const store = Redux.createStore(
			SubscriptionAppReducer,
			initialState,
			Redux.applyMiddleware(thunkMiddleware)
		)

		ReactDOM.render(<SubscriptionAppContainer
			store={store}
			ajaxPageUrl={props.ajaxPageUrl}
			onClose={()=>{
				ReactDOM.unmountComponentAtNode(div)
				refreshSubscriptionList()
			}}
		/>,div)
	}

	const refreshSubscriptionList = () => {
		new HtmlDataGrid('subscriptionsList').refresh();
	}
}


// WEBPACK FOOTER //
// ./src/subscriptionmanager/subscriptionmanager.tsx